module.exports = __webpack_public_path__ + "fonts/VetoSans-Bold_1.efe33665.woff2";